module.exports = __webpack_public_path__ + "img/MX-A018030A-AS.8e123c40.png";